module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('div', {
    staticClass: "contents",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")])]), _c('p', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "pr_01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/praise#pr01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Praise for God's secretaries")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "fm1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/perface#fm01"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#ch01"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("1 A poore man now arrived at the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Land of Promise")])])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#ch02"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("2 The multitudes of people covered the beautie of the fields")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("3 He sate among graue, learned and reuerend men")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("4 Faire and softly goeth far")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("5 I am for the medium in all things")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("6 The danger never dreamt of, that is the danger")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("7 O Lett me osome thee, lett me preserve thee next to my heart")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("8 We have twice and thrice so much scope for oure earthlie peregrination…")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("9 When we do luxuriate and grow riotous in the gallantnesse of this world")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("10 True Religion is in no way a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gargalisme")]), _vm._v(" only")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("11 The grace of the fashion of it")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("12 Hath God forgotten to be gracious? hath he in anger shut vp his tender mercies?")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('p', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "bm1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/appendices#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Appendices")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "bm2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/sixteenthcentury#bm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("A The Sixteenth-century Bible")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "bm3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/sixcompanies#bm03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("B The Six Companies of Translators")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "bm4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/cchronology#bm04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("C Chronology")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "bm5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/selectbibliography#bm05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Select Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/index#iind",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/aboutauthor#aata",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "cre"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/credits#ccre",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Credits")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "cop"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/copyright#ccop",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "atp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/aboutpublisher#aatp",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("About the Publisher")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 63
// module chunks = 0